export default __webpack_public_path__ + "static/media/code.485908cb.mp3";